export class Faxe {
    id: string;
    libelle: any;
    numero: string;

    constructor(){}
}
